import {
  IModal,
  IModalData,
  ModalStep,
  IModalStep,
  IModalStepData, IModalControlButtonData
} from './index'
import {router} from '@/router'
import {ICustomerExtendData} from "@/entities";

export class Modal implements IModal {
  readonly name: string | Function
  steps: IModalStep[]
  readonly close: Function
  step: number
  subject?: any
  resolveLink?: string
  person?: ICustomerExtendData

  constructor(data: IModalData) {
    this.close = data.close
    this.name = data.name
    this.steps = data.steps.map((step: IModalStepData) => {
      // pass modal props to child
      let onClose = step.close || this.close;
      return new ModalStep({
        ...step,
        close: onClose,
        // add default next/back/ok/cancel handlers
        controls: step.controls?.map((control: IModalControlButtonData) => {
          let handler: Function;
          let controlHandler = control.handler;
          switch (control.type) {
            case "back": {
              handler = this.getControlHandler(this.back.bind(this), controlHandler)
              break
            }
            case "next": {
              handler = this.getControlHandler(this.next.bind(this), controlHandler)
              break
            }
            case "download":
            case "ok": {
              handler = this.getControlHandler(this.ok.bind(this), controlHandler)
              break
            }
            case "reset": {
              handler = this.getControlHandler(this.reset.bind(this), controlHandler)
              break
            }
            default: {
              handler = this.getControlHandler(onClose, controlHandler)
            }
          }
          return {
            ...control,
            handler: handler
          }
        })
      });
    })
    this.subject = data.subject || null
    this.person = data.subject?.customer

    // init dialog step
    let step = data.step
    let stepName = data.stepName
    if (step === undefined && data.stepName) {
      this.steps.forEach((s: IModalStep, index: number) => {
        if (s.name === stepName) {
          step = index
        }
      })
    }
    this.step = this.limitStep(step)

  }

  private limitStep(step: number | undefined): number {
    if (step === undefined) {
      return 0
    } else {
      let len = this.steps.length
      step = step % len
      return (step < 0) ? (len - step) : step
    }
  }

  private getControlHandler (defaultHandler: Function, promiseHandler?: Function): Function {
    let self = this;
    return promiseHandler ? (() => {
      let step = self.currentStep
      if (step) {
        step.loading = true;
      }
      (promiseHandler())?.then((res?: any) => {
        self.resolveLink = res?.redirect;
        defaultHandler();
      }).catch(() => {}).finally(() => {
        if (step) {
          step.loading = false;
        }
      });
    }) : defaultHandler
  }

  get handlerUpdater(): (defaultHandler: Function, promiseHandler?: Function) => Function {
    return this.getControlHandler.bind(this);
  }

  validate(): boolean {
    return true
  }

  next(): void {
    if (this.step === this.steps.length - 1) {
      // close dialog, if there're steps overflow
      this.ok()
    } else {
      // step on next
      this.step++
    }
  }

  back(): void {
    if (this.step === 0) {
      // close dialog, if there're steps overflow
      this.close()
    } else {
      // step on next
      this.step--
    }
  }

  ok(): void {
    this.reset();
    let link = this.resolveLink;
    if (link) {
      router.push(link);
    }
  }

  reset(): void {
    this.close();
    setTimeout(() => {
      this.step = 0 // reset dialog flow
    }, 300)
  }

  get title(): string {
    let name = this.name;
    return (typeof name === 'string') ? name : (name as any)();
  }

  get currentStep(): IModalStep | undefined {
    return this.steps[this.step];
  }

}
